interface ZoomComponentProps {
  label: string
  onClick: () => void
}

const ZoomComponent = ({ label, onClick }: ZoomComponentProps) => {
  return (
    <div
      className="bg-green rounded-[9px] w-[36px] h-[36px] text-white text-[26px] font-bold font-decimal flex items-center justify-center cursor-pointer user"
      onClick={onClick}
      role="button"
      style={{
        userSelect: 'none',
      }}
    >
      {label}
    </div>
  )
}
export default ZoomComponent
